export default function GuessIcon() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" fill="currentColor" stroke="currentColor">
        <path d="M50,1.3C23.1,1.3,1.3,23.1,1.3,50S23.1,98.7,50,98.7c26.9,0,48.7-21.8,48.7-48.7S76.9,1.3,50,1.3z M54.6,72.1  H46v-7.4h8.6V72.1z M54.7,55v4.2H46V46.9h4.3c3.6,0,6.5-2.9,6.5-6.5c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5h-8.7  c0-8.4,6.8-15.2,15.2-15.2S65.5,32,65.5,40.4C65.5,47.3,61,53.1,54.7,55z"></path>
      </svg>
    </div>
  );
}
